var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 4.2px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #003d4b;\n        stroke: #003d4b;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 1.42px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.72,96.6H5.28c-.71,0-1.28-.57-1.28-1.28V50.43c0-.71,.57-1.28,1.28-1.28s1.28,.57,1.28,1.28v43.62H93.45V50.43c0-.71,.57-1.28,1.28-1.28s1.28,.57,1.28,1.28v44.89c0,.71-.57,1.28-1.28,1.28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,74.9c-.71,0-1.28-.57-1.28-1.28V4.68c0-.71,.57-1.28,1.28-1.28s1.28,.57,1.28,1.28V73.62c0,.71-.57,1.28-1.28,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,81.38h0c-.8,0-1.54-.38-2-1.03l-18.25-25.6c-.79-1.11-.53-2.64,.58-3.43,1.11-.79,2.64-.53,3.43,.58l16.24,22.79,16.24-22.79c.79-1.11,2.33-1.36,3.43-.58,1.11,.79,1.36,2.33,.58,3.43l-18.25,25.6c-.46,.65-1.21,1.03-2,1.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBlue);
export default __webpack_public_path__ + "static/media/download-icon-blue.ed138fdca434fcf4da615d554e642818.svg";
export { ForwardRef as ReactComponent };